/**
 * Storage is not always there to be used: a browser can block it outright, and a write can hit the
 * quota. A remembered value is not worth taking a feature down with it, so every call is a best
 * effort and a failed one leaves the caller at its own default.
 */
export function readLocalStorage(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.warn(`Failed to read localStorage key "${key}".`, error)
    return null
  }
}

export function writeLocalStorage(key: string, value: string | null): boolean {
  try {
    value === null ? localStorage.removeItem(key) : localStorage.setItem(key, value)
    return true
  } catch (error) {
    console.warn(`Failed to write localStorage key "${key}".`, error)
    return false
  }
}
